import React from 'react'

function BenchTest() {
  return (
    <main>
        <h1>bench Test For Muscular Strength</h1>

    </main>
  )
}

export default BenchTest